import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import { addClass, removeClass, addStyle } from '@studiometa/js-toolkit/utils';

/**
 * Toast component
 */
export default class Filters extends withBreakpointObserver(Base) {
  filtersOpen = false;
  /**
   * Component Configuration
   */
  static config = {
    name: 'Filters',
    refs: ['filtersPanel', 'filtersButton'],
    components: {},
    options: {
      activeBreakpoints: {
        type: String,
        default: 'xxs xs s',
      },
    },
  };

  /**
   * Mount component
   * @returns {void}
   */
  mounted() {
    this.currentItem = null;
  }

  /**
   * Toggle filters panel visibility
   */
  toggleFilters() {
    this.filtersOpen = !this.filtersOpen;

    if (this.filtersOpen) {
      removeClass(this.$refs.filtersPanel, 'hidden');
      addClass(this.$refs.filtersButton, 'hidden');
      addStyle(this.$el, { zIndex: '50' });
      addClass(this.$el, 'h-screen');
    } else {
      this.closeFilters();
      addStyle(this.$el, { zIndex: '40' });
      removeClass(this.$el, 'h-screen');
    }
  }

  /**
   * Close all submenu when closing Menu
   * @returns {void}
   */
  closeFilters() {
    addClass(this.$refs.filtersPanel, 'hidden');
    removeClass(this.$refs.filtersButton, 'hidden');
  }
}
